<template>
  <v-snackbar
    elevation="0"
    v-model="obtenerDatosAlerta.visibilidad"
    color="error"
    top
    @click="cerrar"
  >
    <v-icon>mdi-alert</v-icon>
    {{ obtenerDatosAlerta.mensaje }}
  </v-snackbar>
</template>

<script>
import { setTimeout } from 'timers'
import { mapGetters, mapActions } from 'vuex'
import { InsertaLogMixin } from '@/mixins/credito/InsertaLog.mixin'

export default {
  computed: {
    ...mapGetters({
      obtenerDatosAlerta: 'alerta/obtenerDatosAlertaError',
    }),
  },
  mixins: [InsertaLogMixin],
  watch: {
    obtenerDatosAlerta: {
      handler(value) {
        if (value) {
          var v = this
          setTimeout(() => {
            v.cerrar()
          }, this.obtenerDatosAlerta.tiempo)
        }
        console.error(this.obtenerDatosAlerta)
        this.track(this.obtenerDatosAlerta)
      },
      deep: true,
    },
  },
  methods: {
    cerrar() {
      this.restablecerAlertaError()
    },
    track(mensaje) {
      this.$gtag.exception({
        description: mensaje.mensaje
          ? mensaje.mensaje
          : JSON.stringify(mensaje),
        fatal: false,
      })
      this.InsertaLog({ exception_error: mensaje.mensaje.substring(0, 1000) })
    },
    ...mapActions({
      restablecerAlertaError: 'alerta/restablecerAlertaError',
    }),
  },
}
</script>

<style></style>
